import React from 'react';
import classnames from 'classnames';

import { IconTick } from '@xingternal/designkit';

import styles from './StepCounter.css';

const createRangeArray = length => [...Array(length).keys()];

const StepCounter = ({
  numberOfSteps = 4,
  currentStep = 0,
  allComplete = false,
}) => {
  if (allComplete) {
    currentStep = numberOfSteps;
  }
  return (
    <div className={styles.stepCounterContainer}>
      {createRangeArray(numberOfSteps).map(idx => [
        idx === currentStep && (
          <div className={styles.stepCounterItem} key={idx}>
            {idx + 1}
          </div>
        ),
        idx > currentStep && (
          <div
            className={classnames(styles.stepCounterItem, styles.futureItem)}
            key={idx}
          >
            {idx + 1}
          </div>
        ),
        idx < currentStep && (
          <div
            className={classnames(styles.stepCounterItem, styles.pastItem)}
            key={idx}
          >
            <IconTick width={12} height={12} />
          </div>
        ),
        idx !== numberOfSteps - 1 && (
          <div
            key={`separator${idx}`}
            className={styles.stepCounterSeparator}
          />
        ),
      ])}
    </div>
  );
};

export default StepCounter;
